import { PollQuestionProps } from './types';

export const PollQuestion = ({ question, classNames }: PollQuestionProps) => (
    <div data-testid="pollQuestion" className={`${classNames}`}>
        {question}
    </div>
);
